/**
 * @generated SignedSource<<ebebdce34107369e406f0b44a0dd7f44>>
 * @relayHash 4932afa88e6286c0cea28c6d84392dcf
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/568.0.0-2026-07-14T15:45:45.091Z/TradeBenefitsQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsQuery$variables = {
  userId: string;
};
export type TradeBenefitsQuery$data = {
  readonly viewer: {
    readonly user: {
      readonly tradeFirm: {
        readonly rewards: {
          readonly " $fragmentSpreads": FragmentRefs<"trackingHelpers_rewards">;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsCurrentTier_tradeFirm" | "TradeBenefitsPlanningProject_tradeFirm" | "useTradeBenefitsContact_tradeFirm">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"trackingHelpers_user">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsCurrentTier_viewer" | "TradeBenefitsFaq_viewer" | "TradeBenefitsHero_viewer" | "TradeBenefitsPlanningProject_viewer" | "TradeBenefitsYourFirm_viewer" | "useTradeBenefitsContact_viewer">;
  };
};
export type TradeBenefitsQuery = {
  response: TradeBenefitsQuery$data;
  variables: TradeBenefitsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVerifiedTrade",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Profile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    (v5/*:: as any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortCopy",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TradeBenefitsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TradeBenefitsHero_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useTradeBenefitsContact_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TradeBenefitsCurrentTier_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TradeBenefitsPlanningProject_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TradeBenefitsFaq_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TradeBenefitsYourFirm_viewer"
          },
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "trackingHelpers_user",
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "args": null,
                "argumentDefinitions": []
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TradeFirmType",
                "kind": "LinkedField",
                "name": "tradeFirm",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useTradeBenefitsContact_tradeFirm"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TradeBenefitsCurrentTier_tradeFirm"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TradeBenefitsPlanningProject_tradeFirm"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TradeFirmRewards",
                    "kind": "LinkedField",
                    "name": "rewards",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "trackingHelpers_rewards",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ParentProgram",
                            "kind": "LinkedField",
                            "name": "currentProgram",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LoyaltyProgram",
                                "kind": "LinkedField",
                                "name": "programInfo",
                                "plural": false,
                                "selections": [
                                  (v4/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "args": null,
                        "argumentDefinitions": []
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "TradeBenefitsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "tradeRep",
            "args": [
              {
                "kind": "Literal",
                "name": "relationshipType",
                "value": "TRADE"
              },
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "userIds.0",
                    "variableName": "userId"
                  }
                ],
                "kind": "ListValue",
                "name": "userIds"
              }
            ],
            "concreteType": "UserRelationship",
            "kind": "LinkedField",
            "name": "userRelationships",
            "plural": true,
            "selections": [
              {
                "alias": "userDataB",
                "args": null,
                "concreteType": "RepData",
                "kind": "LinkedField",
                "name": "userDataBRep",
                "plural": true,
                "selections": [
                  (v5/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "photoUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "formatType",
                        "value": "INTERNATIONAL"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "phoneNumber",
                    "storageKey": "phoneNumber(formatType:\"INTERNATIONAL\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSystemUser",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "allConversations",
            "args": [
              {
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userId"
              },
              {
                "kind": "Literal",
                "name": "showInactiveUsers",
                "value": false
              }
            ],
            "concreteType": "ConversationsSolrConnection",
            "kind": "LinkedField",
            "name": "conversationsSolr",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationsFacetGroups",
                "kind": "LinkedField",
                "name": "facets",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConversationsFacets",
                    "kind": "LinkedField",
                    "name": "buyerTags",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unread",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activePrivateOffer",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activeHold",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TradeFirmType",
                "kind": "LinkedField",
                "name": "tradeFirm",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TradeFirmPublicProfileType",
                    "kind": "LinkedField",
                    "name": "publicProfile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "profilePhoto",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TradeFirmRewards",
                    "kind": "LinkedField",
                    "name": "rewards",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ParentProgram",
                        "kind": "LinkedField",
                        "name": "currentProgram",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LoyaltyProgram",
                            "kind": "LinkedField",
                            "name": "programInfo",
                            "plural": false,
                            "selections": [
                              (v8/*:: as any*/),
                              (v6/*:: as any*/),
                              (v4/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusYears",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ParentProgram",
                        "kind": "LinkedField",
                        "name": "nextYearProgram",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LoyaltyProgram",
                            "kind": "LinkedField",
                            "name": "programInfo",
                            "plural": false,
                            "selections": [
                              (v4/*:: as any*/),
                              (v6/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "kind": "LinkedField",
                        "name": "currentYearSpend",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "amount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pointsNeededToLevelUp",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pointsToMaintainStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ParentProgram",
                        "kind": "LinkedField",
                        "name": "nextProgram",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LoyaltyProgram",
                            "kind": "LinkedField",
                            "name": "programInfo",
                            "plural": false,
                            "selections": [
                              (v4/*:: as any*/),
                              (v8/*:: as any*/),
                              (v6/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TradeFirmMemberType",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userId",
                        "storageKey": null
                      },
                      (v7/*:: as any*/),
                      (v6/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*:: as any*/),
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/568.0.0-2026-07-14T15:45:45.091Z/TradeBenefitsQuery",
    "metadata": {},
    "name": "TradeBenefitsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2f0a9d534f2ee93157f1440b98e8fd21";

export default node;
